import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function WardPage({ ward, t, onBack, user, setUser }) {
  const [data, setData] = useState(null);
  const [wardModal, setWardModal] = useState(null);

  useEffect(() => {
    api.get(`/wards/${ward.number}`).then((r) => setData(r.data)).catch(() => {});
  }, [ward.number]);

  return (
    <>
      <SimplePage title={`Ward ${ward.number} · ${ward.name}`} onBack={onBack}>
        <div className="ward-stat-row">
          <CivicStat icon={<FileText />} value={data?.stats?.total ?? 0} label={t.reported} />
          <CivicStat icon={<Clock3 />} value={data?.stats?.in_progress ?? 0} label={t.progress} />
          <CivicStat icon={<CheckCircle2 />} value={data?.stats?.resolved ?? 0} label={t.resolved} />
        </div>

        <section className="ward-seo-intro">
          <p>
            {ward.name} Ward {ward.number} is part of the Vijayanagar area of Bengaluru. This ward page provides public civic information, complaint activity and category-level issue data to help residents understand local civic concerns and report problems through the Vijayanagar Civic Portal.
          </p>
        </section>

        <div className="ward-content-grid">
          <div className="ward-info-panel">
            <span className="eyebrow">WARD {ward.number}</span>
            <h2>Ward Civic Activity</h2>
            <p>
              View current complaint activity and category distribution for this ward.
            </p>

            <div className="hero-buttons">
              <button
                type="button"
                className="civic-btn primary"
                onClick={() => setWardModal("report")}
              >
                <FileText size={17} />
                {t.report}
              </button>

              <button
                type="button"
                className="civic-btn secondary"
                onClick={() => setWardModal("track")}
              >
                <Search size={17} />
                {t.track}
              </button>
            </div>
          </div>

          <div className="ward-map-card">
            <MapPin size={25} />
            <strong>{ward.name}</strong>
            <span>Ward {ward.number}</span>
          </div>
        </div>

        <section className="civic-data-panel">
          <h2>Issues by Category</h2>
          {(data?.categories || []).length === 0 ? (
            <p>No complaints reported in this ward yet.</p>
          ) : (
            data.categories.map((item) => (
              <div className="data-row" key={item.category}>
                <span>{item.category}</span>
                <strong>{item.count}</strong>
              </div>
            ))
          )}
        </section>

        <section className="civic-data-panel">
          <h2>Recent Complaints</h2>
          {(data?.recent_complaints || []).map((item) => (
            <div className="data-row" key={item.tracking_id}>
              <span>
                <strong>{item.tracking_id}</strong> · {item.title}
              </span>
              <b>{item.status}</b>
            </div>
          ))}
        </section>
      </SimplePage>

      {wardModal && (
        <Modal
          type={wardModal}
          user={user}
          setUser={setUser}
          close={() => setWardModal(null)}
          t={t}
        />
      )}
    </>
  );
}


export default WardPage;
